import { Component, OnInit } from '@angular/core';
import {OktaAuthService} from '@okta/okta-angular';
import {AuthenticationService} from '../../services/authentication.service';
import {UserService} from '../../services/user.service';
import {UserInfo} from '../../data/classes/user-info';
import {environment} from 'src/environments/environment';

@Component({
    selector: 'unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent implements OnInit {
    productName = environment.productName;
    contactEmail = environment.contactEmail;
    user: UserInfo;

    constructor(
        private oktaAuth: OktaAuthService,
        private authenticationService: AuthenticationService,
        private userService: UserService
    ) { }

    ngOnInit() {
        this.userService.getUser().then(user => {
            this.user = user;
        })
    }

    logout() {
        this.oktaAuth.logout().then(() => {
            this.authenticationService.updateAuthenticationState(false);
        }).catch((err) => console.log(err));
    }
}
